import "./searchCompGeneral.scss";

function SearchCompGeneral({
  handleSubmit,
  loadingResult,
  setSearchValue,
  searchValue,
  isDisabled = false,
  placeholder = 'ابحث عن رقم وظيفي أو اسم',
  moreWidthForTheSearchComp = false,
}) {
  return (
    <form onSubmit={handleSubmit}>
      <div className={`manage_data_search_part ${moreWidthForTheSearchComp ? "more_width" : ""}`}>
        <input
          type="text"
          placeholder={placeholder}
          className="manage_data_search_part_inp"
          dir="rtl"
          value={searchValue}
          onChange={(e) => { setSearchValue(e.target.value); }}
        />
        <button type="submit" className="manage_data_search_part_btn ds-btn ds-btn--primary" disabled={isDisabled}>
          {loadingResult ? <>يتم البحث</> : <>ابحث</>}
        </button>
      </div>
    </form>
  );
}

export default SearchCompGeneral;
